/**
 * Service: resources
 */
angular.module('acme.common.service.resources', [
  'acme.common.service.helpers',
  'acme.common.service.calendar'
])
.service('ResourcesService', [ 'HelpersService', 'CalendarService', function(HelpersService, CalendarService) {

    return {
      
      schedule: {},
      
      init: function() {
        return true;
      },

      prepareRequest: function(request) {
        var r = request;
        
        r.resourceTimeFrame.end.timeFrame = r.resourceTimeFrame.end.timeFrame.type;
        r.resourceTimeFrame.end.allocation = r.resourceTimeFrame.end.allocation.type;
        r.resourceTimeFrame.end.type = r.resourceTimeFrame.end.type.type;

        r.resourceTimeFrame.start.timeFrame = r.resourceTimeFrame.start.timeFrame.type;
        r.resourceTimeFrame.start.allocation = r.resourceTimeFrame.start.allocation.type;
        r.resourceTimeFrame.start.type = r.resourceTimeFrame.start.type.type;

        return r;
      },
      
      setSchedule: function (schedule) {
        this.schedule = schedule;
      },
      
      processRequest: function(request) {
        var r = request;

        if (request.resourceTimeFrame) {
          r.startTime = this.processRequestTime(request.resourceTimeFrame.start);
          r.endTime = this.processRequestTime(request.resourceTimeFrame.end);
        }

        if (request.eventResource) {
          r.category = HelpersService.cap(HelpersService.getEntityName(request.eventResource.resourceCategory).displaySingular);
          r.quantity = request.eventResource.quantity;
          r.resourceTemplate = request.eventResource.type;
          r.resource = request.eventResource.resourceName || '';
          if(request.eventResource.values instanceof Array) {
            r.attributes = request.eventResource.values.join(', ');
          } else if(typeof request.eventResource.values === 'string') {
            r.attributes = request.eventResource.values;
          }
        }

        return r;
      },
      
      processRequestTime: function(time) {
        var r = [];

        // 1 hour 30 mins
        if (time.timeFrame !== 'when') {
          r.push(CalendarService.durationToString(time.duration));
        }

        // before
        r.push(time.timeFrame);

        if (time.timeFrame !== 'duration') {
          // every instance
          if (this.schedule.repeatCycle === 'never') {
            r.push('the event');
          } else {
            r.push(time.allocation.toLowerCase() + ' instance');
          }
          // starts
          r.push(time.type.toLowerCase());
        }

        return HelpersService.cap(r.join(' '));

      },
      
      processRequests: function(requests) {
        var i, ii, r = [];
        for (i = 0, ii = requests.length; i < ii; i++) {
          r.push( this.processRequest(requests[i]) );
        }
        return r;
      }

    };

}]);